import { render } from "./DeleteServiceModal.vue?vue&type=template&id=8fe66dce"
import script from "./DeleteServiceModal.vue?vue&type=script&lang=js"
export * from "./DeleteServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__